import { Add } from "@mui/icons-material";
import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

import ButtonCst from "@components/ButtonCst";
import { buildTestId, getRouteSection } from "@utils/utilsTestIds";

interface HeroProps {
  title: string;
  description: string;
  buttonLabel?: string;
}

const HeroCst: React.FC<HeroProps> = ({ title, description, buttonLabel }) => {
  const { area, section } = getRouteSection(useLocation().pathname);

  return (
    <Box sx={{ padding: description ? "24px 0 16px" : "24px 0 40px" }}>
      <Typography
        variant="h3"
        component="h2"
        id={buildTestId(area, section, "page-title")}
        data-testid={buildTestId(area, section, "title")}
        aria-label={title}
        sx={{
          mb: "8px",
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="subtitle2"
          sx={{
            mb: "24px",
          }}
        >
          {description}
        </Typography>
      )}
      {buttonLabel && (
        <ButtonCst id={"add-button"} variant={"contained"} text={buttonLabel}>
          <Add />
        </ButtonCst>
      )}
    </Box>
  );
};

export default HeroCst;
